var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 148 148",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "#0166FF",
    rx: 74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m74.184 15.016-.012-.053v.106l-8.336 36.395 8.336 18.011v.052l.012-.026.012.026v-.052l8.336-18.011-8.336-36.395v-.106zM73.837 132.889l.012.053v-.106l8.336-36.395L73.85 78.43v-.052l-.012.026-.012-.026v.052L65.49 96.44l8.336 36.396v.106zM124.47 43.257l.045-.046-.106.066-35.32 12.062-10.924 16.56-.047.028.03-.003-.02.03.056-.035 19.693-2.39 26.55-26.23.099-.062zM23.518 104.646l-.046.046.107-.066 35.32-12.062 10.923-16.56.047-.028-.03.003.02-.03-.056.035-19.693 2.39-26.55 26.23-.1.062zM23.653 43.064l-.056-.02.098.062 26.451 26.34 19.687 2.466.048.03-.017-.026.032.004-.05-.03-10.86-16.605L23.71 43.084l-.098-.061zM124.356 104.844l.056.02-.098-.062-26.451-26.339-19.687-2.467-.048-.03.017.026-.032-.004.05.03 10.86 16.606 35.277 12.201.098.061z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81b41debdce3cc6036b308f711f40a10.svg";
export { ForwardRef as ReactComponent };